import axios from "axios";
import * as Sentry from "@sentry/react";

export const $axios = axios.create({
  baseURL: process.env.API_URL,
  timeout: 15000,
  withCredentials: true,
});

export const $axios_home = axios.create({
  baseURL: `${process.env.HOME_API_URL}`,
  timeout: 15000,
  withCredentials: true,
});

export const $axios_tomarch = axios.create({
  baseURL: `${process.env.TOMARCH_API_URL}`,
  timeout: 15000,
  withCredentials: true,
});

export const $axios_design_whos = axios.create({
  baseURL: `${process.env.DESIGN_WHOS_API_URL}`,
  timeout: 15000,
  withCredentials: true,
});

$axios.interceptors.response.use(
  (res) => res,
  async (err) => {
    const { method, url, params, data, baseURL, headers: _headers } = err.config;
    const { data: responseData, status } = err.response;
    const responseURL = `${baseURL}${url}`;
    const headers: { [key: string]: any } = {};

    Object.entries(_headers).forEach(([key, value]) => (headers[key] = value));

    if (err.response.status !== 401 && err.response.status !== 403 && err.response.status !== 404) {
      Sentry.setContext("API Request Detail", {
        method,
        url,
        params,
        data,
        headers,
      });
      Sentry.setContext("API Response Detail", {
        status,
        responseData,
      });
      Sentry.setTag("type", "axiosError");
      Sentry.withScope((scope) => {
        scope.setFingerprint([method, status, url]);
        Sentry.captureException(new Error(`${responseURL} (${status})`));
      });
    }

    if (err.response.status === 401 || err.response.status === 403) {
      window.location.href = `${process.env.ENERGYX_LOGOUT_URL}`;
      return;
    }
    throw err;
  }
);

$axios_home.interceptors.response.use(
  (res) => res,
  async (err) => {
    const { method, url, params, data, headers: _headers } = err.config;
    const { data: responseData, status } = err.response;
    const { responseURL } = err.request;
    const headers: { [key: string]: any } = {};

    Object.entries(_headers).forEach(([key, value]) => (headers[key] = value));
    if (err.response.status !== 401 && err.response.status !== 403 && err.response.status !== 404) {
      Sentry.setContext("API Request Detail", {
        method,
        url,
        params,
        data,
        headers,
      });
      Sentry.setContext("API Response Detail", {
        status,
        responseData,
      });
      Sentry.setTag("type", "axiosError");
      Sentry.withScope((scope) => {
        scope.setFingerprint([method, status, url]);
        Sentry.captureException(new Error(`${responseURL} (${status})`));
      });
    }

    throw err;
  }
);

/*

$axios_design_whos.interceptors.response.use(
  (res) => res,
  async (err) => {
    const { method, url, params, data, headers: _headers } = err.config;
    const { data: responseData, status } = err.response;
    const { responseURL } = err.request;
    const headers: { [key: string]: any } = {};

    Object.entries(_headers).forEach(([key, value]) => (headers[key] = value));

    Sentry.setContext("API Request Detail", {
      method,
      url,
      params,
      data,
      headers,
    });
    Sentry.setContext("API Response Detail", {
      status,
      responseData,
    });
    Sentry.setTag("type", "axiosError");
    Sentry.withScope((scope) => {
      scope.setFingerprint([method, status, url]);
      Sentry.captureException(new Error(`${responseURL} (${status})`));
    });

    throw err;
  }
);

$axios_tomarch.interceptors.response.use(
  (res) => res,
  async (err) => {
    const { method, url, params, data, headers: _headers } = err.config;
    const { data: responseData, status } = err.response;
    const { responseURL } = err.request;
    const headers: { [key: string]: any } = {};

    Object.entries(_headers).forEach(([key, value]) => (headers[key] = value));

    Sentry.setContext("API Request Detail", {
      method,
      url,
      params,
      data,
      headers,
    });
    Sentry.setContext("API Response Detail", {
      status,
      responseData,
    });
    Sentry.setTag("type", "axiosError");
    Sentry.withScope((scope) => {
      scope.setFingerprint([method, status, url]);
      Sentry.captureException(new Error(`${responseURL} (${status})`));
    });

    throw err;
  }
);

*/
